import "./IconTable.scss";
import { ReactComponent as TableIcon } from "./svg/icon_table.svg";

export const IconTable = ({ width = "2.5rem", height = "2.5rem" }: { width?: string; height?: string }) => {
  const renderIcon = () => {
    return <TableIcon />;
  };

  return (
    <span className={`icon-table`} style={{ width, height }} data-testid="icon-table">
      {renderIcon()}
    </span>
  );
};
